export default "__VITE_ASSET__Bu2CjxL2__";